import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled, { css } from 'foundations-theming/utils';
import { tableButtonStyles } from './tableButtonStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const TitleHoverButton = styled.button.withConfig({
  displayName: "MilestoneTitleHoverButton__TitleHoverButton"
})(["", ""], ({
  theme
}) => {
  return css(["align-items:center;background:transparent;border:none;cursor:text;display:inline-flex;flex:1;gap:", ";margin:0 -", ";min-width:0;overflow:hidden;padding:", " ", ";width:auto;", ""], theme.space['100'], theme.space['100'], theme.space['50'], theme.space['100'], tableButtonStyles);
});
const MilestoneTitleHoverButton = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TitleHoverButton, Object.assign({}, props, {
    children: children
  }));
};
export default MilestoneTitleHoverButton;